import { useAuth } from "@/lib/auth";
import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

const AdminLogin = () => {
  const { login, user, loading } = useAuth();
  useSeo({ title: "Admin · Asia Sourcing", path: "/admin/login", noindex: true });

  return (
    <main
      style={{
        minHeight: "100svh",
        background: "var(--ink)",
        color: "var(--paper)",
        display: "grid",
        placeItems: "center",
        padding: "2rem",
      }}
      data-testid="admin-login-page"
    >
      <div style={{ maxWidth: "32rem", width: "100%", textAlign: "center" }}>
        <p
          className="mono"
          style={{ color: "var(--brass)", letterSpacing: ".14em", marginBottom: "1.4rem" }}
        >
          Asia Sourcing · Admin
        </p>
        <h1
          className="display"
          style={{ fontSize: "clamp(2rem, 4vw, 3rem)", margin: "0 0 1rem", lineHeight: 1.1 }}
        >
          Sign in to view leads.
        </h1>
        <p style={{ color: "rgba(239,234,224,.62)", maxWidth: "44ch", margin: "0 auto 2.4rem" }}>
          Authentication is restricted to a single founder account. Only the configured
          admin Google email is allowed past this screen.
        </p>

        {loading ? (
          <p className="mono" style={{ color: "var(--brass-deep)" }}>Checking session…</p>
        ) : user ? (
          <div style={{ display: "flex", flexDirection: "column", gap: ".8rem", alignItems: "center" }}>
            <p className="mono" style={{ color: "var(--brass)" }}>
              Already signed in as {user.email}
            </p>
            <Link to="/admin/leads" className="btn btn-fill btn-lg" data-testid="admin-go-leads">
              <span>Continue to leads →</span>
            </Link>
          </div>
        ) : (
          <button
            type="button"
            onClick={login}
            className="btn btn-fill btn-lg btn-glow"
            data-testid="admin-google-login"
          >
            <span>Sign in with Google →</span>
          </button>
        )}

        <p
          className="mono"
          style={{
            color: "rgba(239,234,224,.32)",
            fontSize: ".62rem",
            letterSpacing: ".1em",
            marginTop: "3rem",
          }}
        >
          ← <Link to="/" style={{ color: "inherit" }}>Back to site</Link>
        </p>
      </div>
    </main>
  );
};

export default AdminLogin;
